<template>
  <el-container>
    <el-header>
      <el-form @submit.native.prevent style="width:100%;padding-top: 10px;">
        <el-row type="flex" class="row-bg" justify="space-between">
          <query-gather :is-add="true" :is-input="true" :is-query="true" :is-reset="true"
                        :cur-input-tip="curInputTip"
                        @qgAddDeal="setSk(false,'新增水库')" @qgDelAllDeal="handleAllDelete" @qgQueryDeal="getSkglPage_"
                        @qgResetDeal="chongzhi"></query-gather>
        </el-row>
      </el-form>
    </el-header>
    <el-main style="padding-left: 15px;padding-right:15px;padding-bottom: 10px;">
      <div style="background-color: #ffffff;padding-left: 5px;padding-right:5px;height: 100%;position: relative;">
        <el-table
            :data="tableData"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            border
            size="mini"
            style="width:100%;padding: 5px"
            height="calc(100% - 60px)"
            max-height="calc(100% - 60px)"
            @sort-change="cdSortChange"
            @selection-change="handleSelectionChange"
            :row-style="tableRowClassName"
            :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.4rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'6.5vh'}">
        >
          <template v-for="(item,index) in skTitles">
            <template v-if="index ===0">
              <el-table-column
                  :prop="item.prop"
                  :width="item.width"
                  :label="item.label"
                  :align="item.align"
                  :sortable="item.sortable"
                  show-overflow-tooltip
                  v-if="!item.isFilter">
                <template slot-scope="scope">
                  <a style="cursor: pointer;color: #46adf5"
                     @click="skFirstItemClickDeal(scope.row)">{{ scope.row.rescd }}</a>
                </template>
              </el-table-column>
            </template>
          <template v-else>
            <el-table-column
                :prop="item.prop"
                :width="item.width"
                :label="item.label"
                :align="item.align"
                :sortable="item.sortable"
                show-overflow-tooltip
            >
            </el-table-column>
          </template>
          </template>
          <el-table-column label="操作" align="center"   width="250" >
            <template slot-scope="scope">
              <el-tooltip content="删除" effect="light"  v-if="authority.del">
                <el-popconfirm style="margin-left: 10px" title="确定删除吗？"  @confirm="handleDelete(scope.row)">
                  <img src="~@/assets/images/operates/delete.png" alt="" slot="reference" style="cursor: pointer;"/>
                </el-popconfirm>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div style="width:100%;position: absolute;bottom: 10px;">
          <pageFooter :current-change="handleCurrentChange" :size-change="handleSizeChange" :rForm="params"></pageFooter>
        </div>
        <skOpen :dialog="dialog" @reset="reset"/>
      </div>
    </el-main>
  </el-container>
</template>

<script>

import skOpen from "./open/skOpen.vue";
import pageFooter from "@/components/pageFooter.vue";
import QueryGather from "../../components/buttonGather/queryGather";
export default {
  components: {
    skOpen,pageFooter,QueryGather},
  name: "skgl",
  data() {
    return {
      authority: {},
      loading: false,
      isRead: false,
      isEdit:false,
      isReadOrEdit:false,
      curInputTip:'请输入水库名称或水库代码查询',
      tableData: [],
      multiple: true,
      params: {
        total: 1,
        size: 20,
        current: 1,
        nameOrRescd:'',
        categoryCode:''
      },
      multipleSelection: [],
      dialog:{
        title:"",
        formVisible:false,
        isReadOrEdit:this.isReadOrEdit,
        data:{}
      },
      //用户授权dialog
      sqdialog:{
        formVisible:false,
        data:{},
        jsdata:[],
        defaultTree:[],
        defaultSelect:[],
      },
      stHeight:"0",
      skTitles: [
        {prop: 'rescd', label: '水库代码', align: 'center', sortable: true, isFilter: false,},
        {prop: 'name', label: '水库名称',  align: 'center', sortable: true, isFilter: false,},
        {prop: 'no', label: '序号',  align: 'center', sortable: true, isFilter: false,},
      ],
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let authList = JSON.parse(localStorage.getItem("thirdAuthority"))['section'];
      this.authority.read = true;
      this.authority.del = true;
      this.authority.edit = true;
      this.authority.query = true;
    },
    skFirstItemClickDeal(row){
      if(this.authority.edit){
        this.setSk(row,'水库信息')
      }else if(this.authority.read){
        this.setSk(null);
      }

    },
    cdSortChange(column) {
      let params = {
        total: 1,
        size: 20,
        current: 1,
        nameOrRescd:'',
        categoryCode:'',
        sortCol: column.prop,
        order: column.order === "descending" ? 1 : 0,
      };
      this.params = {};
      this.params = params;
      this.getSkglPage_();
    },
    tableRowClassName({row, rowIndex}) {
      return {
        backgroundColor: '#ffffff',
        fontSize: '16px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontFamily: 'PingFang SC',
        color: '#323232',
        height: '5.83vh',
      };
    },
    //查询
    getSkglPage_(params){
      if(typeof params !="undefined"){
        this.params.nameOrRescd = params.curInputValue;
      }
      this.params.current = 1
      this.getSkglPage();
    },
    getSkglPage() {
      this.request.get("/rm-bres/v1/page", {params: this.params}).then(res => {
        if (res.ok) {
          this.tableData = res.data.records;
          this.params.total = res.data.total;
          this.params.size = res.data.size;
        }
      })
    },
    handleSizeChange(val) {
      this.params.size = val;
      this.params.current = 1
      this.getSkglPage();
    },
    handleCurrentChange(val) {
      this.params.current = val;
      this.getSkglPage();
    },
    handleDelete(row){
      this.request.delete("/rm-bres/v1/"+row.rescd,).then(res => {
        if (res.ok) {
          this.$message.success("删除成功");
          this.params.current = 1
          this.getSkglPage();
        }
      })
    },
    handleAllDelete(){
      let selection =[]
      for(let s of this.multipleSelection){
        selection.push(s.rescd)
      }
      //console.log('selection',selection)
      if(!selection){
        this.$message.info("请至少选中一行删除！");
      }
      this.request.delete("/rm-bres/v1/rescds",{data:selection}).then(res => {
        if (res.ok) {
          this.$message.success("批量删除成功");
          this.params.current = 1;
          this.getSkglPage();
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.multiple = !val.length;
    },
    setSk(scope,title){
      if(scope){
        this.isEdit = true;
        this.request.get("/rm-bres/v1/"+scope.rescd, {params: scope.rescd}).then(res => {
          if (res.ok) {
            this.dialog.data = res.data
          }
        })
      }
      this.isRead = title === '水库信息';
      this.dialog.title = title
      this.dialog.formVisible = true
      if( title === '查看水库'|| title === '水库信息'){
        this.dialog.isReadOrEdit=true
      }else{
        this.dialog.isReadOrEdit=false
      }
    },
    chongzhi(){
      this.params.nameOrRescd =''
      this.params.total = 1;
      this.params.size= 20;
      this.params.current= 1;
      this.getSkglPage();
    },
    // 表单重置
    reset() {
      this.dialog.data = {}
      this.sqdialog.data = {}
      this.sqdialog.jsdata = {}
      this.getSkglPage();
    },

  },
  created() {
    this.getSkglPage();
    let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
    this.stHeight = windowHeight - 260;
  }
}
</script>
<style scoped>
::v-deep .el-main {
  display: block;
  flex: 1;
  flex-basis: auto;
  overflow: auto;
  box-sizing: border-box;
  padding: 10px;
}
.lightgreen-box {
  background-color: lightgreen;
  height: 24px;
}
.orange-box {
  background-color: orange;
  height: 24px;
}
.pl10{
  padding-left: 10px;
}
.pb10{
  padding-left: 10px;
}
</style>
